import { inject } from '@angular/core';
import {
  CanActivateFn,
  Router,
  UrlTree,
} from '@angular/router';

const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

export const preQualifyGuard: CanActivateFn = (_route, state): boolean | UrlTree => {
  const url = state.url;
  if (url.includes('/success')) return true;

  try {
    const raw = localStorage.getItem('introducerContext');
    if (raw) {
      const context = JSON.parse(raw) as { IntroducerId?: string; BusinessId?: string; storedAt?: number };
      const isExpired = context.storedAt != null && Date.now() - context.storedAt > THIRTY_DAYS_MS;
      if ((context.IntroducerId || context.BusinessId) && !isExpired) return true;
    }
  } catch (err) {
    console.error('[PreQualify:Guard] Failed to parse introducer context from localStorage', err);
  }

  return inject(Router).createUrlTree(['/pre-qualify/welcome']);
};
